const { each, some, uniq } = require('lodash');

class FormValidationSummaryController {
    constructor($scope, $element, moveFocus) {
        this.$element = $element;
        this.moveFocus = moveFocus;
        $scope.$on('$submitted', () => {
            moveFocus($element.find('._errorMessage'));
        });
    }

    $onInit() {
        // We need to track the form's prototype so that we can check if a field in error
        // is actually a whole nested form
        this.formPrototype = Object.getPrototypeOf(this.form).constructor;
    }

    hasValidationErrors() {
        return this.form.$submitted && some(this.form.$error);
    }

    getElementsWithErrorsForForm(form, formName = null) {
        let elementsWithErrors = [];

        each(form.$error, (errorType) => {
            each(errorType, (error) => {
                const parentFormName = error.$$parentForm ? error.$$parentForm.$name : ' ';
                // Recursive for ng-forms
                if (error instanceof this.formPrototype) {
                    elementsWithErrors = elementsWithErrors.concat(this.getElementsWithErrorsForForm(error, parentFormName));
                } else {
                    // If the form does not have a name, ensure it's unique (by using a space)
                    // This will not work if there is a ng-repeat of ng-forms with the same name
                    // - a unique name must be used for this to work correctly
                    elementsWithErrors.push(`${formName || ''}${parentFormName}${error.$name}`);
                }
            });
        });

        return uniq(elementsWithErrors);
    }

    errorCount() {
        return this.getElementsWithErrorsForForm(this.form).length;
    }

    setFocusOnFirstError() {
        this.moveFocus(this.$element.parent(`[name=${this.form.$name}]`).find('.ng-invalid:focusable').first());
    }
}

FormValidationSummaryController.$inject = ['$scope', '$element', 'MoveFocus'];

const formValidationSummaryComponentDefinition = {
    controller: FormValidationSummaryController,
    bindings: {
        userMessage: '@?',
        serverErrorMessage: '@?',
    },
    require: {
        form: '^form',
    },
    template: require('./form-validation-summary.component.html').trim(),
};

module.exports = {
    FormValidationSummaryController,
    formValidationSummaryComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/form-validation-summary/form-validation-summary.component.js